import { useEffect, useRef, useState } from "react";

export const useTimer = () => {
  const lastStarted = useRef<number>(Date.now());
  const timerRef = useRef<NodeJS.Timer | null>(null);
  const [timerMilliSeconds, setTimerMilliSeconds] = useState<null | number>(
    null
  );

  const timerFunc = () => {
    const currentTime = Date.now();

    const diffMilliseconds = currentTime - lastStarted.current;

    setTimerMilliSeconds(diffMilliseconds);
  };

  const onStart = () => {
    lastStarted.current = Date.now();
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    timerRef.current = setInterval(timerFunc, 100);
  };

  const onReset = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    setTimerMilliSeconds(null);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  return { timerMilliSeconds, onStart, onReset };
};
